import request from '@/utils/request';

/**
 *  用户信息接口
 * @returns {{getUserInfo: (function(*=): *)}}
 */
export function userApi () {
    return {
        //用户列表
        getUserList: params => {
            return request ({
                url: '/admin/user/list',
                method: 'get',
                params,
            });
        },

        //用户详情
        getUserInfo: params => {
            return request ({
                url: '/admin/user/info',
                method: 'get',
                params,
            });
        },

        //用户记录
        getUserRecords: params => {
            return request ({
                url: '/admin/user/records',
                method: 'get',
                params,
            });
        },

        //用户编辑
        edit: params => {
            return request ({
                url: '/admin/user/edit',
                method: 'post',
                data: params,
            });
        },

        //用户记录
        getViewAnalysis: params => {
            return request ({
                url: '/admin/user/view_analysis',
                method: 'get',
                params,
            });
        },

    };
}
